import { Controller } from "@hotwired/stimulus"

// Registers the POS service worker for offline resilience. Used only on POS pages
// so the SW scope stays on the operational area.
export default class extends Controller {
  static values = { url: String, scope: String }

  connect() {
    if (!("serviceWorker" in navigator)) return

    navigator.serviceWorker
      .register(this.urlValue, { scope: this.scopeValue || "/" })
      .catch(() => {})
  }
}
